import { logError } from "common/error";
export function assertTrue(value, name) {
    if (value === false) {
        logError(`${name} is false`);
    }
}
export function assertNull(value, name) {
    if (value !== null) {
        logError(`${name} is not null`);
    }
}
export function assertNotNull(value, name) {
    if (value == null) {
        logError(`${name} is null`);
    }
}
export function assertNotNulls(...values) {
    let id = 0;
    for (const value of values) {
        assertNotNull(value, String(id));
        id += 1;
    }
}
export function assertNumber(maybenum) {
    if (typeof maybenum !== "number") {
        logError(`${maybenum} is not a number`);
        return;
    }
    if (isNaN(maybenum)) {
        logError(`${maybenum} is not a number`);
    }
}
//# sourceMappingURL=assert.js.map